/**
 * /moniteur/messages — Placeholder messagerie moniteur.
 */
import React from 'react';
import { Mail, ExternalLink } from 'lucide-react';

export default function MoniteurMessagesPage() {
  return (
    <div className="max-w-3xl" data-testid="moniteur-messages-page">
      <div className="text-[10.5px] font-black uppercase tracking-[0.22em] text-rose-500 mb-2">Messages</div>
      <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>Boîte mail</h1>
      <p className="text-sm text-white/60 mt-2 mb-6">Échange avec tes élèves et le secrétariat.</p>
      <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-6">
        <div className="flex items-start gap-3">
          <Mail className="w-6 h-6 text-rose-400" />
          <div className="flex-1">
            <div className="text-white font-semibold">Messagerie interne</div>
            <div className="text-white/60 text-sm mt-1">La messagerie interne arrive en Phase 3. Pour l’instant, utilise ton email pro.</div>
            <a href="mailto:contact@code2roues.fr" className="mt-3 inline-flex items-center gap-2 text-rose-400 hover:text-rose-300 text-sm font-semibold">
              contact@code2roues.fr <ExternalLink size={12} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
